import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const CaAccordionWrapper = (props) => {
  const { group } = props

  return (
    <ResponseConsumer
      response={(group || {}).status ? group.status : group}
      content={() => <CaAccordion {...props} />}
    />
  )
}

const CaAccordion = ({ expandCallback, group, selectCallback }) => {
  const cxNames = {
    accordionContainer: 'mb6',
    groupHeader: {
      depthStyle: () => {
        return 'bg-white black b--light-sea-green-2'
      },
      iconDepthStyle: depth => {
        switch (depth) {
          case 2:
            return 'white'
          default:
            return 'black o-80'
        }
      }
    },
    contentHeader: {
      borderColor: 'b--light-sea-green-2',
      headerBackground: 'bg-ghost-grey'
    },
    content: {
      divider: 'bt--light-sea-green-2'
    },
    borderColor: 'b--light-sea-green-2'
  }

  return (
    <AccordionWrapperContainer
      {...{ expandCallback, group, selectCallback, cxNames }}
      title={null}
      eventCategory='CA'
      showAllS1
      SectionHeaderOverride={() => null}
      styleTitle={false}
      contained
    />
  )
}

export default CaAccordionWrapper
